import { createRouter, createWebHistory } from 'vue-router'
import PublicForm from '../pages/PublicForm.vue'
import Register from '../pages/Register.vue'
import SubmitSuccess from '../pages/SubmitSuccess.vue'
import AdminLogin from '../pages/admin/Login.vue'
import AdminDashboard from '../pages/admin/Dashboard.vue'
import { useAuth } from '../stores/auth'
import AdminUsers from '../pages/admin/Users.vue'
import Czplanding from '../pages/Czplanding.vue'

const routes = [
  { path: '/', redirect: '/register' },
  { path: '/apply', component: PublicForm },
  { path: '/success', component: SubmitSuccess },
  { path: '/admin', component: AdminLogin },
  { path: '/register', component: Register },
  { path: '/czplanding', component: Czplanding },
  { path: '/admin/dashboard', component: AdminDashboard, meta: { requiresAuth: true} },
  { path: '/admin/users', component: AdminUsers, meta: { requiresAuth: true} },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, _from, next) => {
  const auth = useAuth();
  if (to.meta.requiresAuth && !auth.isAuthed) {
    await auth.check();
    if (!auth.isAuthed) return next('/admin');
  }
  next();
})

export default router
